// extracted by mini-css-extract-plugin
export default {"consumers":"Consumers_consumers__kEIFk","con":"Consumers_con__fsOT+","logoname":"Consumers_logoname__trJBZ"};